import './divider';
import './second-panel';
import './subscribe-updates';
import '@rxdi/ui-kit/divider';

import { Component, html, LitElement } from '@rxdi/lit-html';
import { VsCodeIcon } from '@shared/icons/apps/vscode';

const PlanetBackground = new URL('./planet.png', import.meta.url).href;

/**
 * @customElement root-component
 */
@Component({
  selector: 'root-component',
  template(this: RootComponent) {
    return html`
      <div style="margin-top:100px;margin-bottom: 20px;">
        <div></div>
      </div>

      <react-reveal .delay=${0}>
        <flex-grid
          .$items=${[
            html`
              <style>
                .container {
                  max-width: 560px;
                }
                .title {
                  font-size: 2.75em;
                  font-weight: 700;
                }
                @media (max-width: 640px) {
                  .container {
                    padding: 0px 20px 0px 20px;
                    text-align: center;
                  }
                }
              </style>
              <div class="container">
                <h1 class="title">It's Time To Build, From Cloud To Edge.</h1>
                <p style="font-size: 1.2em;  line-height: 1.7em;">
                  Build faster, real-time applications and APIs on our secure, programmable stateful-serverless Edge
                  Cloud.
                </p>
              </div>
            `,
            html`
              <style>
                figure {
                  width: auto; /*container-width*/
                  overflow: hidden; /*hide bounds of image */
                  margin: 0; /*reset margin of figure tag*/
                  margin-left: -140px;
                }
                figure img {
                  display: block; /*remove inline-block spaces*/
                  width: 100%; /*make image streatch*/
                }
                figure img {
                  /*add to other styles*/
                  margin: -14% 0px;
                }
              </style>
              <figure>
                <img src=${PlanetBackground} />
              </figure>
            `,
          ]}
        >
        </flex-grid>
      </react-reveal>
      <div style="   background: white; width: 100%">
        <react-reveal .delay=${250}>
          <second-panel></second-panel>
        </react-reveal>
      </div>
      <div style="height: 30px;"></div>
      <react-reveal .delay=${500}>
        <flex-grid
          .$items=${[
            html`
              <style>
                .container {
                  max-width: 560px;
                }
                .title {
                  font-size: 2.75em;
                  font-weight: 700;
                }
                @media (max-width: 640px) {
                  .container {
                    padding: 0px 20px 0px 20px;
                    text-align: center;
                  }
                }
              </style>
              <div class="container">
                <h1 class="title">Instant dev environments.</h1>
                <p style="font-size: 1.2em;  line-height: 1.7em;">
                  Graphql Cloud is an open source universal standard that allows projects to define their own
                  development environment, allowing for consistent, reproducible, and instant environments. Contribute
                  sooner and debug faster.
                </p>
              </div>
            `,
            html` <div style="text-align: center;">${VsCodeIcon(200, 200)}</div> `,
          ]}
        >
        </flex-grid>
      </react-reveal>
      <div style="height: 30px;"></div>
      <div style="background: var(--global-background, white); width: 100%;text-align: center; padding-top: 40px;">
        <react-reveal .delay=${500}>
          <divider-component></divider-component>
        </react-reveal>
      </div>

      <div
        style="background: var(--global-background, white); width: 100%; margin:0 auto; text-align: center;     font-size: 32px;"
      >
        <react-reveal .delay=${750}>
          <rx-divider></rx-divider>
          Infrastructure built for <br /><strong>application developers</strong>
          <div style="height: 30px"></div>
          <rx-divider></rx-divider>
        </react-reveal>
      </div>

      <div>
        <react-reveal .delay=${1000}>
          <subscribe-updates></subscribe-updates>
        </react-reveal>
      </div>
    `;
  },
})
export class RootComponent extends LitElement {}
